import { all, AllEffect } from 'redux-saga/effects';
import { mainSaga } from './features/main';
import { loginSaga } from './features/login';
import { resultSaga } from './features/result';
import { resultDetailsSaga } from './features/resultDetails';
import { resultPreviewSaga } from './features/resultPreview';

export default function* sagas(): Generator<AllEffect<unknown>, void, unknown> {
  yield all([
    loginSaga(),
    resultSaga(),
    resultDetailsSaga(),
    resultPreviewSaga(),
    mainSaga(),
  ]);
}
